import Icon from '../components/Icon.vue'

Icon.register({
  'text-height': {
    width: 576,
    height: 512,
    paths: [
      {
        d: 'M16 32H304C312.8 32 320 39.2 320 48V144C320 152.8 312.8 160 304 160H268.5C259.7 160 252.5 152.8 252.5 144V96H197.7V416H232C240.8 416 248 423.2 248 432V464C248 472.8 240.8 480 232 480H88C79.2 480 72 472.8 72 464V432C72 423.2 79.2 416 88 416H122.3V96H67.5V144C67.5 152.8 60.3 160 51.5 160H16C7.2 160 0 152.8 0 144V48C0 39.2 7.2 32 16 32zM491.3 36.7L571.3 116.7C581.3 126.7 574.3 144 560 144H512V368H560C575.6 368 580.6 386 571.3 395.3L491.3 475.3C485.1 481.6 474.9 481.6 468.7 475.3L388.7 395.3C378.7 385.3 385.7 368 400 368H448V144H400C384.4 144 379.4 126 388.7 116.7L468.7 36.7C474.9 30.4 485.1 30.4 491.3 36.7z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/text-height.js
// module id = aH8d
// module chunks = 144